module.exports = __webpack_public_path__ + "media/images/footer_nofondo-ac1d2a059716f8aa212575916fdfc4bd.png";